import React , { useState ,useEffect }  from "react";
import { PlusIcon, MinusIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";
import {
useCompanyFinRatios
} from 'data/company';
import {useCompanyFin} from "contexts/companyfindata/companyfindata.context.tsx"

import {number_format,APP_URL , capitalizeWords , formatINR} from 'components/config/Common';
import RatioGraphSection from 'components/company/RatioGraphsection';

import {useAuth} from 'contexts/provider/AuthProvider';
import LockedOverlay from 'components/ui/LockedOverlay.tsx';
import {Links} from 'routes/PathLink';
import ModalView from '_utils/ModalView'
import LoginwithEmail from "components/auth/user/LoginwithEmail";
import SocialLogin from "components/auth/SocialLogin";

export default function RatioSection({companyinfo,type}) {
  const {isUser} = useAuth();
          const [open, setOpen] = useState(false);
              
              const openPopup = () => {
                  setOpen(true);
              };
      const [openSections, setOpenSections] = useState({});
    // Map to store background color of each parent section
    const parentBgMap = {};
    const [viewType, setViewType] = useState('Consolidated');
   // const [valuesroce, setValuesRoce] = useState(null);
// possible values: 'Standalone' | 'Consolidated'
  const toggleSection = (sectionno) => {
    setOpenSections((prev) => ({
      ...prev,
      [sectionno]: !prev[sectionno],
    }));
  };

  const {pldata} = useCompanyFin();
  
   useEffect(() => {
      // code runs whenever `type` changes
      console.log('Type changed RATIO:', type);
      if(type){
        setViewType(capitalizeWords(type));
      }else{
        setViewType('Consolidated');
      }
      
      /*refetchFR({id:companyinfo?.id,type:(type?'Consolidated':'Standalone'),
        company_type:companyinfo?.company_type,
      });
      */
    }, [type]);

  

    const {
      quarterlyresult,
      years_list,
      lable_array:labelArray,
      isLoading: loading,
      error,
      refetch:refetchFR,
    } = useCompanyFinRatios({id:companyinfo?.id,company_type:companyinfo?.company_type
    });

    console.log("company_type ration",companyinfo?.company_type);
const getSecByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.postfix : null;
};

const getTextcssByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.textbold : null;
};


const hasConsolidatedData =
  quarterlyresult?.["Consolidated"] &&
  Object.keys(quarterlyresult["Consolidated"]).length > 0;

const hasStandaloneData =
  quarterlyresult?.["Standalone"] &&
  Object.keys(quarterlyresult["Standalone"]).length > 0;

// Decide final view type
let finalViewType = viewType;

if (viewType === "Consolidated" && !hasConsolidatedData && hasStandaloneData) {
  finalViewType = "Standalone";
}

// Use finalViewType everywhere
const selectedData = quarterlyresult?.[finalViewType] ?? {};
const selectedYearlist = years_list?.[finalViewType] ?? {};


  //const selectedData = quarterlyresult?.[viewType] ?? {};
 // const selectedYearlist = years_list?.[viewType] ?? {};


   /* useEffect(() => {
  //const data = getLatestYearData(apiData, "ROCE", 5);

  const valuesrocenew = getLatestYearData(selectedData,'ROCE %')
  setValuesRoce(valuesrocenew);
}, [selectedData]);
*/

  const valuesroce = getLatestYearData(selectedData,'ROCE %');
  const valuesroe = getLatestYearData(selectedData,'ROE %');
  const valuessales = getLatestYearData(pldata,'Sales');
  const valuesrevenu = getLatestYearData(pldata,'Revenue');

  const valuesnetprofit = getLatestYearData(pldata,'Net Profit');
  const valueseps = getLatestYearData(pldata,'EPS in Rs');


  console.log("PROFIT LOSS DATA",pldata);

  console.log("valuessales",valuessales);
 // console.log("valuesroce years",valuesroce?.years);

  //console.log("ratio data for ROCE",selectedData);

  function getLatestYearData(dataObj, key, yearsCount = 5) {
  if (!dataObj[key]) return { years: [], values: [] };

  // Convert object → array
  const entries = Object.entries(dataObj[key])
    .map(([year, valArr]) => ({
      year,
      value: valArr?.[0] !== null ? Number(valArr[0]) : null
    }))
    .filter(item => item.value !== null); // remove null years

  // Sort by year (2014 Mar → 2015 Mar → ...)
  entries.sort((a, b) => {
    const yearA = parseInt(a.year);
    const yearB = parseInt(b.year);
    return yearA - yearB;
  });

  // Take latest N years
  const latest = entries.slice(-yearsCount);

  return {
    years: latest.map(i => i.year),
    values: latest.map(i => i.value)
  };
}

const getDecimalByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.decimal : null;
};



const hasValidData = (dataset) => {
  return (
    dataset &&
    Array.isArray(dataset?.years) &&
    Array.isArray(dataset?.values) &&
    dataset.years.length > 1 &&
    dataset.values.length > 1
  );
};

const showSection =
  hasValidData(valueseps) ||
  hasValidData(valuesnetprofit) ||
  hasValidData(valuesrevenu) ||
  hasValidData(valuessales) ||
  hasValidData(valuesroe) ||
  hasValidData(valuesroce);

const hasConsolidated =
  quarterlyresult?.["Standalone"] &&
  Object.keys(quarterlyresult["Standalone"]).length > 0;

  return (  
    <>
    <div className="relative">
      <section className="bg-white shadow-md z-50 rounded-xl py-5">
        <h2 className="text-2xl font-semibold px-5">Ratios</h2>
        
        <div className="text-heading px-5">
                 Standalone Figures in Rs. Crores
                  {!type && hasConsolidated && (
                    <>
                      {" / "}
                      <Link
                        to={`${APP_URL}/company/${companyinfo?.symbol}/standalone`}
                        className="text-accent underline ml-1"
                      >
                        View Standalone
                      </Link>
                    </>
                  )}
        
                  {type && (
                    <>
                      {" / "}
                      <Link
                        to={`${APP_URL}/company/${companyinfo?.symbol}`}
                        className="text-accent underline ml-1"
                      >
                        View Consolidated
                      </Link>
                    </>
                  )}
                </div>
        {viewType === "Consolidated" && finalViewType === "Standalone" && (
          <div className="px-5 text-sm text-yellow-600">
            Consolidated data not available. Showing Standalone results instead.
          </div>
        )}
        <div className="py-4"></div>
        {loading?
        null
        :
        <div class="relative overflow-x-auto bg-neutral-primary-soft shadow-xs rounded-base ">
            <table class="w-full text-sm text-left border-0 rtl:text-right text-body">
                <thead class="bg-neutral-secondary-soft border-b border-default">
                    <tr >
                        <th scope="col" class="px-6 py-2 font-medium">
                           
                        </th>
                         {Object.entries(selectedYearlist).map(([keyyear, valyear]) => (
                            <th scope="col" className="text-right px-4 py-2 font-medium">{valyear}</th>
                          ))}
                    </tr>
                </thead>
                <tbody>
                 {Object.keys(selectedData || {}).length === 0 ? (
                                  <div className="p-5 text-heading"> data is not ready yet, please check again
                                </div>
                                    ) : (<>
                {Object.entries(selectedData).map(([period, qresults],index) => {
                  const postfix = getSecByName(period);
                  const textbold = getTextcssByName(period);
                  const decimalval =  getDecimalByName(period);
                  return(<React.Fragment key={period}>  
                   <tr 
                   className={`${textbold} odd:bg-gray-50  cursor-pointer`}
                    >
                      <td className={`px-6 py-2 text-black`} >
                        <div className={`flex gap-1 whitespace-nowrap items-center`}>{period}
                            </div>
                        </td>
                      {Object.entries(qresults).map(([key, qresultsval]) => (
                          <td className={`text-right px-4 py-3 text-black`} >{formatINR(qresultsval,decimalval)}{postfix}</td>
                      ))}
                      </tr>
                   </React.Fragment>)
                })}
                </>
                 )}
                </tbody>
            </table>
        </div>
        }

        

      </section> 
      {showSection && (
      <div className="flex flex-col md:flex-row w-full space-y-5 md:space-y-0 md:space-x-5 py-4">
        {companyinfo?.company_type == null  ?
           <div className="w-full md:w-3/12" >
            {valuesroce && valuesroce?.years && valuesroce?.values && companyinfo?.company_type == null &&
              <RatioGraphSection heading='Roce %' infocontent={`The graph here shows the ROCE % of past 5 Year data`} type="percent" years={valuesroce?.years} values={valuesroce?.values}  />
            }
          </div>
            :
            <div className="w-full md:w-3/12" >
              {valuesroe && valuesroe?.years && valuesroe?.values && 
                <RatioGraphSection heading='Roe %' infocontent={`The graph here shows the ROE % of past 5 Year data`} type="percent" years={valuesroe?.years} values={valuesroe?.values}  />
              }
            </div>
        }
      {companyinfo?.company_type == null  ?
       <div className="w-full md:w-3/12" >
          {valuessales && valuessales?.years && valuessales?.values &&
            <RatioGraphSection heading='Sales' infocontent={`The graph here shows the Net sales of past 5 Year data`} type="amount" years={valuessales?.years} values={valuessales?.values}  />
          }
        </div>
      :

      <div className="w-full md:w-3/12" >
          {valuesrevenu && valuesrevenu?.years && valuesrevenu?.values &&
            <RatioGraphSection heading='Revenue' infocontent={`The graph here shows the Net sales of past 5 Year data`} type="amount" years={valuesrevenu?.years} values={valuesrevenu?.values}  />
          }
        </div>
      }

        <div className="w-full md:w-3/12" >
          {valuesnetprofit && valuesnetprofit?.years && valuesnetprofit?.values &&
            <RatioGraphSection heading='Net Profit' infocontent={`The graph here shows the Net Profit of past 5 Year data`} type="amount" years={valuesnetprofit?.years} values={valuesnetprofit?.values}  />
          }
        </div>
         <div className="w-full md:w-3/12" >
          {valueseps && valueseps?.years && valueseps?.values &&
            <RatioGraphSection heading='Eps in Rs.' infocontent={`The graph here shows the Eps in Rs. of past 5 Year data`} type="price" years={valueseps?.years} values={valueseps?.values}  />
          }
        </div>
      </div>)
      }
      {!isUser &&
                                           <>
                                           <div className="min-h-fit py-10 md:py-0">
                                             <img src={`${APP_URL}/img/analysis_placeholder.png`} className="h-10" />
                                           </div>
                                 <LockedOverlay 
                                       show={!isUser}
                                     >
                                        <p className="text-lg font-semibold mb-3">
                                     Login to unlock full analysis
                                   </p>
                               
                                   <Link
                                     to={'#'}
                                     onClick={openPopup}
                                     className="inline-block bg-accent text-white px-4 py-2 rounded-lg font-semibold  transition"
                                   >
                                     Click Here to Login
                                   </Link>
                                </LockedOverlay>
                                </>
                                  }
                       </div>
                       <ModalView open={open} onClose={() => setOpen(false)}>
                                           <div className="flex flex-col justify-center">
                                               <div className="text-center text-base text-body">Don't have an account? <Link to={`${Links.USER_SIGNUP}`} className="text-accent underline transition-colors duration-200 hover:text-accent-hover hover:no-underline focus:text-accent-hover focus:no-underline focus:outline-none ltr:ml-1 rtl:mr-1">Create New</Link></div>
                                               
                                     </div>  
                                           <LoginwithEmail goTo={window.location.href} />
                                           <SocialLogin mode='Login' user_type='user' goTo={window.location.href} />
                                       </ModalView>
      </>
  );
}
